import * as React from "react";
const SvgFiRrCrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crow_svg__a)">
      <path
        fill="#062147"
        d="M23.987 6.137c-.284-1.43-1.273-2.245-2.082-2.683A4.14 4.14 0 0 0 20.318.811c-1.045-.798-2.388-1.055-3.686-.7a4.1 4.1 0 0 0-2.694 2.401 4.4 4.4 0 0 0-.288 1.055c-.19 1.362-.676 2.455-1.496 3.307L.228 21.364a1 1 0 0 0 1.544 1.272L3.118 21h5.764l1.224 2.447a1 1 0 0 0 1.342.448 1 1 0 0 0 .447-1.342l-.809-1.617a10.7 10.7 0 0 0 2.474-.58l1.546 3.092a1 1 0 0 0 1.342.448 1 1 0 0 0 .447-1.342l-1.524-3.048c3.332-1.95 5.63-5.6 5.63-9.676 0 0 .002-2.795.005-2.828h2.253c.455 0 .817-.417.728-.863zM13 8.988v.574c0 2.873-2.182 5.233-4.935 5.425zm6.551-3.61A2.9 2.9 0 0 0 19 7.1v2.728C19 14.8 14.844 19 9.924 19H4.763l1.73-2.102c.397.068.803.102 1.209.102C11.726 17 15 13.663 15 9.562V6.154a8.9 8.9 0 0 0 .63-2.313q.04-.283.158-.57a2.12 2.12 0 0 1 1.369-1.23c.701-.192 1.393-.065 1.946.358.544.416.856 1.046.856 1.73 0 .448-.142.88-.408 1.248"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrow;
